import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { TeamRostersReportModel } from 'src/app/reports/team-rosters-report/team-rosters-report.model';
import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';
import { CustomView } from 'src/app/shared/components/odata-filter/models/custom-view';
import { ViewContext } from 'src/app/shared/components/odata-filter/models/view-context';
import { CustomViewService } from 'src/app/shared/services/custom-view.service';
import { WidgetsService } from 'src/app/shared/services/widgets.service';
import { WidgetInstanceModel } from '../../shared/models/widget.model';
import { RecentAcceptsService } from './recent-accepts.service';
import { WorkspaceService } from 'src/app/shared/services/workspace.service';
import { Workspace } from 'src/app/shared/models/workspace/workspace';

@Component({
  selector: 'app-recent-accepts',
  templateUrl: './recent-accepts.component.html',
  styleUrls: ['./recent-accepts.component.scss'],
  standalone: false,
  // Scoped per instance so two Recently Accepted widgets don't share state.
  providers: [RecentAcceptsService]
})
export class RecentAcceptsComponent implements OnInit, OnDestroy {
  @Input() widgetInfo: WidgetInstanceModel;

  workspaces: Workspace[] = [];
  subscriptions: Subscription[] = [];
  odataResult: TeamRostersReportModel[] = [];
  loaded = false;
  activeWorkspaceIsOrg = false;
  invitedPeopleCount = 0;
  private _selectedView: CustomView;
  private _views: CustomView[] = [];
  itemPickerValues: ItemPickerModel[] = [];
  constructor(
    private recentAcceptsService: RecentAcceptsService,
    private customViewService: CustomViewService,
    private widgetsService: WidgetsService,
    private workspaceService: WorkspaceService
  ) {}
  ngOnInit(): void {
    this.subscriptions.push(
      this.customViewService.customViews
        .pipe(
          map((views) => {
            //get first default team view which is All Active Teams
            if (views) {
              return views.filter((f) => f.viewContext == ViewContext.Teams && !f.isTemporary);
            }
          })
        )
        .subscribe((views) => {
          if (views) {
            this._selectedView =
              views.find((x) => x.id == this.widgetInfo?.settings?.selectedViewId) ?? views[0];
            this._views = views;
            this.itemPickerValues = this._views.map((x) => new ItemPickerModel(x.id, null, x.name));
            this.recentAcceptsService.getRecentAccepts(this._selectedView);
          }
        }),

      this.recentAcceptsService.recentAccepts.subscribe((result) => {
        this.loaded = true;
        this.odataResult = [];
        if (result && result.length > 0) {
          this.odataResult = result;
        } else if (result && result.length == 0) {
          //loads the number of invited people based on the selected view in the past 30 days to show the result in a message on the UI
          this.recentAcceptsService
            .getRecentInvitedPeopleCount(this._selectedView)
            .subscribe((x) => (this.invitedPeopleCount = x));
        }
      }),

      this.workspaceService.currentWorkspaces.subscribe((ws) => {
        if (ws === undefined) return;
        if (ws != null) {
          this.workspaces = ws.workspaces;
          this.activeWorkspaceIsOrg = ws.activeWorkspace.id == null;
        }
      })
    );
  }
  get selectedItemPickerValue(): ItemPickerModel {
    return this.itemPickerValues.find((x) => x.id == this._selectedView.id);
  }
  itemPickerSelect(model: ItemPickerModel) {
    this._selectedView = this._views.find((x) => x.id == model.id);
    this.loaded = false;
    this.recentAcceptsService.getRecentAccepts(this._selectedView);
    this.widgetInfo.settings = {
      ...this.widgetInfo.settings,
      selectedViewId: this._selectedView.id
    };
    this.widgetsService.updateInstanceSettings(this.widgetInfo);
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
